exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-bar {\n  padding: 5px 0; }\n\n.negative-offset {\n  margin-top: -15px; }\n\n.modify-icon {\n  padding: 0;\n  width: 100%;\n  min-width: 20px; }\n\n.font-80p {\n  font-size: 80%; }\n\n.no-wrap-bold-text {\n  font-weight: bold;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/modules/mobile/views/master-data/m-master-data.component.scss
// module id = ../../../../../angular/app/modules/mobile/views/master-data/m-master-data.component.scss
// module chunks = main